export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=403faf7edfa50bcdf3028c7cdc75611ff149b2ca72&name=revalidateCommunity!'